import { render, staticRenderFns } from "./RecentLiveStreamsList.vue?vue&type=template&id=f6b7270e&scoped=true&"
import script from "./RecentLiveStreamsList.vue?vue&type=script&lang=js&"
export * from "./RecentLiveStreamsList.vue?vue&type=script&lang=js&"
import style0 from "./RecentLiveStreamsList.vue?vue&type=style&index=0&id=f6b7270e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b7270e",
  null
  
)

export default component.exports